<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <base-text-field label="Nom" v-model="data.nom"/>

    <base-text-field label="E-mail" v-model="data.email" />

    <base-text-field label="Sujet" v-model="data.sujet" />

    <base-textarea
      class="mb-6"
      label="Une description de votre demande"
      v-model="data.texte"
    />
    <p v-html="rgpd_mention">

    </p>

    <!-- <v-checkbox
              v-model="rgpd"
              :label="rgpd_mention"
              :required="true"
            ></v-checkbox> -->

    <div class="d-flex align-center mb-6">
      <div class="mr-4 text-h6">
        Combien font {{ captcha.num1 }} + {{ captcha.num2 }} ?
      </div>
      <base-text-field
        v-model="captcha.userAnswer"
        label="Réponse"
        type="number"
        hide-details
        style="max-width: 100px"
      />
    </div>

    <div v-if="captchaError" class="error--text mb-4">
      Veuillez répondre correctement à la question de sécurité.
    </div>

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      outlined
      target="_blank"
      @click="sendMessage"
    >
      Envoyer
    </base-btn>
  </div>
</template>

<script>
  import axios from 'axios'
  
  export default {
    name: 'BaseContactForm',
    components: {
    },

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'ENVOYER VOTRE MESSAGE',
      },
    },
    data()  {
      return {
        rgpd: false,
        data : {},
        captcha: {
          num1: 0,
          num2: 0,
          userAnswer: '',
        },
        captchaError: false,
      }
    },
    created() {
      this.generateCaptcha()
    },
    methods : {
      generateCaptcha() {
        this.captcha.num1 = Math.floor(Math.random() * 10) + 1
        this.captcha.num2 = Math.floor(Math.random() * 10) + 1
        this.captcha.userAnswer = ''
      },
      sendMessage(){
        if (parseInt(this.captcha.userAnswer) !== (this.captcha.num1 + this.captcha.num2)) {
          this.captchaError = true
          return
        }
        this.captchaError = false

        // loading and disabling button.
        console.log("sending message")
        // verify data before sending
        this.data.captcha = {
          num1: this.captcha.num1,
          num2: this.captcha.num2,
          answer: this.captcha.userAnswer
        }
        
        // post the message to server
        const self = this
        axios.post('/contact', this.data)
        .then(function (response) {
          console.log(response);
          alert('Message envoyé avec succès !')
          self.data = {}
          self.generateCaptcha()
        })
        .catch(function (error) {
          console.log(error);
          alert("Erreur lors de l'envoi du message.")
        });
      }
    },
    computed: {
      rgpd_mention(){
        return `En remplissant ce formulaire, vous consentez à ce que le Fonds pour l’Indépendance de la Presse, responsable de traitement, utilise les données personnelles vous concernant pour le traitement de votre demande de contact. Conformément à la loi informatique et libertés du 6 janvier 1978 modifiée et au Règlement européen n°2016/679/UE du 27 avril 2016, vous bénéficiez d’un droit d’accès, de modification, de portabilité, de suppression et d’opposition au traitement des informations vous concernant. Vous pouvez exercer ces droits via ce formulaire de contact. Pour toute information complémentaire ou réclamation, vous pouvez contacter la commission nationale de l’informatique et des libertés (plus d’informations sur www.cnil.fr).`
      }
    }
  }
</script>
